<template>
	<div class="main">
        <!-- right -->
        <RdRight :profile='profile'/>
        <!-- top -->
        <RdTop :profile='profile'/>

        <!-- banner -->
        <div class="banner">
            <div class="banner-box">
                <a class="banner-slide" href="javascript:void(0)"><img src="/static/images/banner1.jpg"/></a>
            </div>
        </div>

        <!--contain-->
        <div class="contain">
            <!-- 对名为stuIndex的组件进行缓存 -->
            <keep-alive include="stuIndex">
			    <router-view></router-view>
		    </keep-alive>
        </div>	

        <!-- footer -->
        <RdFooter :profile='profile' />
        
    </div>
</template>
<style src="../../static/css/studentindex.css" scoped></style>
<script>
import RdTop from "./common/RdTop.vue";
import RdFooter from "./common/RdFooter.vue";
import RdRight from "./common/RdRight.vue";
export default {
	data: function () {
		return {
            profile:{},//中心简介，包含邮箱联系方式等信息
		};
	},
	components: {
		RdTop: RdTop, RdFooter: RdFooter, RdRight: RdRight
	},
	methods: {
        //获取中心简介
		getIntroduce(){
            this.$api.get("/api/centerDesc/list", '', (res) => {
                if (res.status == 0) {
                    if(res.data.length > 0){
                        this.profile = res.data[0];
                    }
                    
                } else {
                    this.$message.error(res.message);
                }
            });
        },
	},
    mounted() {
		
	},
    created(){
        this.getIntroduce();
    }
};
</script>



// WEBPACK FOOTER //
// src/views/stuHome.vue